import React from 'react';
import { Route } from 'react-router';
import { withTranslation } from 'react-i18next';

import RecordsBatchUpdate from '../RecordsBatch/RecordsBatchUpdate';
import RecordsBatchDelete from '../RecordsBatch/RecordsBatchDelete';

import RecordController from '../Record/RecordController';
import View from '../App/AppBody/Section/SectionBody/Catalog/View';
import { connect } from '../StateProvider';
import getLink from '../common/router/getLink';
import closeConfirmation from '../common/Modal/closeConfirmation';
import closeRecordConfirmation from '../common/Modal/closeRecordConfirmation';
import routes from '../../routes';
import HashMemoryRouter from '../common/router/HashMemoryRouter';
import NavRoute from '../common/router/Route';
import SCENE_TYPE from '../../configs/sceneTypes';

import uiActions from '../../actions/uiActions';
import sceneActions from '../../actions/sceneActions';

import styles from './multiModal.less';
import SCENE_CONTAINER from '../../configs/sceneContainer';

class ModalSceneContainer extends React.Component {
  state = {};

  componentDidMount() {
    this.prepareComponent();

    // save webForm State
    if (this.props.isWebForm) {
      uiActions.setIsWebForm();
    }
  }

  componentDidUpdate(prevProps) {
    const { catalogId: currentCatalogId, recordId: currentRecordId } = this.props;
    const { catalogId: prevCatalogId, recordId: prevRecordId } = prevProps;

    if (
      (currentCatalogId && currentCatalogId) !== prevCatalogId ||
      (currentRecordId && currentRecordId) !== prevRecordId
    ) {
      this.prepareComponent();
    }
  }

  prepareComponent() {
    const { type, sceneId, sectionId, catalogId, recordId } = this.props;
    let { viewId } = this.props;
    let link;
    let route;
    let component;
    let confirmation = closeConfirmation;

    switch (type) {
      case SCENE_TYPE.CATALOG:
        route = routes.view;
        link = viewId
          ? getLink(null, route, { sectionId, catalogId, viewId })
          : getLink(null, route, { sectionId, catalogId });
        component = ({ match }) => {
          viewId = match.params && match.params.viewId ? match.params.viewId : viewId;

          return <View {...this.props} viewId={viewId} openRecordsInModal />;
        };
        component = <Route path={route.path} render={component} />;

        break;

      case SCENE_TYPE.RECORD:
        route = recordId === '$new' ? routes.newRecord : routes.record;
        link = route && getLink(null, route, { sectionId, catalogId, recordId });
        link = link.pathname;
        confirmation = closeRecordConfirmation;

        component = (
          <NavRoute route={route}>
            {(props) => {
              // change scene params if record route changed
              if (props.match) {
                const routeCatalogId = props.match.params.catalogId;
                const routeRecordId = props.match.params.recordId;
                const routeViewId = props.match.params.viewId;
                const isNewRecord = routeRecordId === '$new';

                // подменить Рекорд при клике по навигации рекордов (в хеадере рекордов)
                // но для новых рекордов, рекорд может навигейтить на recordId=$new, и такое не надо записывать в сцену
                if (routeRecordId !== this.props.recordId && !isNewRecord) {
                  // закрываем текущую сцену
                  sceneActions.deleteScene(sceneId);

                  // открываем новую
                  const params = {
                    catalogId: routeCatalogId,
                    parentSceneId: this.props.parentSceneId,
                    recordId: routeRecordId,
                    viewId: routeViewId,
                    parent: this.props.parent && this.props.parent.toJS()
                  };
                  sceneActions.openRecord(params, {}, SCENE_CONTAINER.POPUP);
                }

                return <RecordController {...this.props} />;
              }
              // after X button click - delete scene after confirmation in ClosePopup
              sceneActions.deleteScene(sceneId);
              return null;
            }}
          </NavRoute>
        );

        break;

      case SCENE_TYPE.RECORDS_BATCH_UPDATE:
        route = routes.batchUpdate;
        link = viewId
          ? getLink(null, route, { sectionId, catalogId, viewId, recordId })
          : getLink(null, route, { sectionId, catalogId, recordId });

        link = link.pathname;
        component = ({ match }) => {
          viewId = match.params && match.params.viewId ? match.params.viewId : viewId;

          return <RecordsBatchUpdate {...this.props} viewId={viewId} />;
        };
        component = <Route path={route.path} render={component} />;

        break;

      case SCENE_TYPE.RECORDS_BATCH_DELETE:
        route = routes.batchDelete;
        link = viewId
          ? getLink(null, route, { sectionId, catalogId, viewId })
          : getLink(null, route, { sectionId, catalogId });
        link = link.pathname;
        component = ({ match }) => {
          viewId = match.params && match.params.viewId ? match.params.viewId : viewId;

          return <RecordsBatchDelete {...this.props} viewId={viewId} />;
        };
        component = <Route path={route.path} render={component} />;

        break;

      default:
        break;
    }

    this.setState({
      link,
      route,
      component,
      confirmation,
    });
  }

  render() {
    const { isActive, type, t } = this.props;
    const { link, component, confirmation } = this.state;

    if (!(type && link && component)) {
      return null;
    }

    return (
      <HashMemoryRouter
        initialEntries={[link]}
        initialIndex={0}
        getUserConfirmation={(message, callback) => confirmation({ message, callback, t })}
      >
        <div style={{ display: isActive ? 'block' : 'none' }} className={styles.scene}>
          {component}
        </div>
      </HashMemoryRouter>
    );
  }
}

export default connect(
  withTranslation()(ModalSceneContainer),
  {
    scenes: ['scenes'],
    catalogs: ['catalogs'],
  },
  (props, { scenes, catalogs }) => {
    const { sceneId } = props;
    const scene = scenes.get(sceneId);
    const type = scene && scene.get('type');
    const parentSceneId = scene && scene.getIn(['parentSceneId']);
    const catalogId = scene && scene.getIn(['params', 'catalogId']);
    const recordId = scene && scene.getIn(['params', 'recordId']);
    const viewId = scene && scene.getIn(['params', 'viewId']);
    const parent = scene && scene.getIn(['params', 'parent']);
    const sectionIdFromScene = scene && scene.getIn(['params', 'sectionId']);
    const sectionIdFromCatalog = catalogs && catalogs.getIn([catalogId, 'sectionId']);
    return {
      sectionId: sectionIdFromScene || sectionIdFromCatalog,
      catalogId,
      recordId,
      viewId,
      type,
      parentSceneId,
      parent,
      ...props,
    };
  },
);
